export default __webpack_public_path__ + "ai-scenec22616.png";